import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=1907bc23&"
import script from "./MyCourse.vue?vue&type=script&lang=js&"
export * from "./MyCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports